import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Book appointment
export const bookAppointment = async (appointmentData) => {
  try {
    const response = await axios.post(`${API}/appointments`, appointmentData);
    return {
      success: true,
      appointment: response.data,
      message: "Appointment booked successfully! Check your email for confirmation."
    };
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.detail || "Failed to book appointment. Please try again."
    };
  }
};

// Get appointment by ID
export const getAppointment = async (appointmentId) => {
  try {
    const response = await axios.get(`${API}/appointments/${appointmentId}`);
    return { success: true, appointment: response.data };
  } catch (error) {
    return {
      success: false,
      message: error.response?.status === 404 
        ? "Appointment not found" 
        : "Failed to fetch appointment"
    };
  }
};

// Reschedule appointment
export const rescheduleAppointment = async (appointmentId, newDate, newTime) => {
  try {
    const response = await axios.put(`${API}/appointments/${appointmentId}`, {
      date: newDate,
      time: newTime
    });
    return {
      success: true,
      appointment: response.data,
      message: "Appointment rescheduled successfully! Check your email for confirmation."
    };
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.detail || "Failed to reschedule appointment"
    };
  }
};

// Cancel appointment
export const cancelAppointment = async (appointmentId) => {
  try {
    const response = await axios.delete(`${API}/appointments/${appointmentId}`);
    return {
      success: true,
      message: response.data.message || "Appointment cancelled successfully"
    };
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.detail || "Failed to cancel appointment"
    };
  }
};

// Get available slots for a date
export const getAvailableSlots = async (date) => {
  try {
    const dateStr = date.toISOString().split('T')[0];
    const response = await axios.get(`${API}/appointments/availability/${dateStr}`);
    return response.data.slots || [];
  } catch (error) {
    return [];
  }
};
